"use client";

import BaseProductDetails from "../../shared/product/base-product-details";
import styles from "./index.module.css";
import { useProductPriceDisplay } from "../../shared/product/useProductPriceDisplay";

const ProductDetails = (props) => (
  <BaseProductDetails
    {...props}
    styles={styles}
    usePriceDisplay={useProductPriceDisplay}
  />
);

export default ProductDetails;
